module.exports = __webpack_public_path__ + "static/media/14A.3cff49bc.png";